export default "__VITE_ASSET__BCFenV$V__"